var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PhoneInput',{attrs:{"value":_vm.value,"default-country-code":_vm.$$i18n.locale == 'cn' ? 'CN' : 'US',"no-example":true,"no-validator-state":true,"name":_vm.name,"translations":{
      countrySelectorLabel: _vm.$t('vuePhoneComponent.Callingcode'),
      phoneNumberLabel: _vm.$t('vuePhoneComponent.EnterPhoneNumber'),
  }},on:{"update":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }